import { createEntityAdapter } from '@reduxjs/toolkit';
import { Vehicle } from '../../../types/vehicle';
import apiSlice from '..';
import { EntityWithCount } from '../types';
import { defaultSerializeQueryArgs } from '@reduxjs/toolkit/dist/query';

type SalesQueryArgs = {
  [x: string]: any;
};

export const salesAdapter = createEntityAdapter<Vehicle>();

export const salesApiSlice = apiSlice.injectEndpoints({
  endpoints: builder => ({
    getMySales: builder.query<EntityWithCount<Vehicle>, SalesQueryArgs>({
      query: filters => ({
        url: 'seller/vehicles/sales',
        method: 'GET',
        params: { limit: 24, offset: 1, auctionStatus: 'active', ...filters }
      }),
      transformResponse: (response: any) => {
        return {
          rows: salesAdapter.addMany(salesAdapter.getInitialState(), response.data.rows),
          count: Number(response.data.count)
        };
      },
      serializeQueryArgs: ({ endpointName, queryArgs, endpointDefinition }) => {
        const { offset, ...restArgs } = queryArgs;
        return defaultSerializeQueryArgs({ queryArgs: restArgs, endpointDefinition, endpointName });
      },
      merge: (currentCache, newItems, { arg, baseQueryMeta }) => {
        const newVehicles = Object.values(newItems.rows.entities) as Vehicle[];
        currentCache.count = newItems.count;
        if (arg.offset === 1) {
          salesAdapter.setAll(currentCache.rows, newVehicles);
        } else {
          salesAdapter.addMany(currentCache.rows, newVehicles);
        }
      },
      forceRefetch({ currentArg, previousArg }) {
        return currentArg?.offset !== previousArg?.offset;
      },
      // async onCacheEntryAdded(arg, { updateCachedData, cacheEntryRemoved, cacheDataLoaded, getState, dispatch }) {
      //   const store = getState() as any;
      //   const userId = store.user?.user?.id;
      //   if (!userId) return;
      //   const socket = getSocket();

      //   const listener = ({ payload, type }: SocketMessage) => {
      //     const socketEventManager = new VehicleSocketEventHandlerManager(updateCachedData, salesAdapter, {
      //       type,
      //       payload
      //     });
      //     socketEventManager.registerHandlers([
      //       WS_VEHICLE_NOTES_UPDATE,
      //       WS_NEW_PROXY,
      //       WS_VEHICLE_DETAILS_UPDATE,
      //       WS_NEW_BID
      //     ]);

      //     if (type === WS_VEHICLE_TIME_END) {
      //       updateCachedData(draft => {
      //         const exists = salesAdapter.getSelectors().selectById(draft.rows, payload.id);
      //         const shouldRemove = arg.auctionStatus === 'active';
      //         if (shouldRemove && exists) {
      //           salesAdapter.removeOne(draft.rows, payload.id);
      //           draft.count -= 1;
      //         } else {
      //           salesAdapter.upsertOne(draft.rows, payload);
      //         }

      //         dispatch(
      //           salesApiSlice.util.updateQueryData('getMySalesCounters', undefined, (counterDraft: any) => {
      //             counterDraft.pending += 1;
      //             counterDraft.active -= 1;
      //           })
      //         );
      //       });
      //     }
      //   };
      //   try {
      //     const data = await cacheDataLoaded;

      //     for (const vehicleId of data.data.rows.ids) {
      //       socket.emit('subscribe', `vehicle-notes:${userId}:${vehicleId}`);
      //       socket.emit('subscribe', `vehicles:${vehicleId}`);
      //     }

      //     socket.on('message', listener);
      //   } catch {}
      //   await cacheEntryRemoved;
      //   socket.off('message', listener);
      // }
    }),
    getMySalesCounters: builder.query<{ active: number; pending: number }, void>({
      query: () => ({
        url: 'seller/vehicles/sales-counters',
        method: 'GET'
      }),
      transformResponse: (response: any) => response.data
    })
  }),
  overrideExisting: true
});

export const { useGetMySalesQuery, useGetMySalesCountersQuery } = salesApiSlice;
